// extracted by mini-css-extract-plugin
module.exports = {"merchantHeader":"support-utilities_merchantHeader__2P5mP","homeLogo":"support-utilities_homeLogo__3qZ7w"};